import { ApiError } from "@/lib/api";
import { Button } from "@/components/ui/Button";
import { ADMIN_FORBIDDEN_MESSAGE } from "./types";

export function isAdminForbidden(error: unknown): boolean {
  return error instanceof ApiError && error.status === 403;
}

export function AdminLoadState({
  error,
  onRetry,
}: {
  error: unknown;
  onRetry: () => void;
}): JSX.Element {
  const forbidden = isAdminForbidden(error);
  return (
    <div role="alert" className="rounded-lg border border-danger/30 bg-danger-bg p-4 text-sm text-danger">
      <p>{forbidden ? ADMIN_FORBIDDEN_MESSAGE : error instanceof Error ? error.message : "読み込みに失敗しました。"}</p>
      <Button className="mt-3" size="sm" variant="secondary" onClick={onRetry}>
        再試行
      </Button>
    </div>
  );
}
